import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Exploitation = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="exploitation"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22.5547 11.3047L20.2148 10.7305C20.0859 10.3203 19.9219 9.92188 19.7227 9.53516L20.918 7.54297C21.0586 7.30859 21.0234 7.01562 20.8359 6.82812L19.1719 5.16406C18.9844 4.97656 18.6914 4.94141 18.457 5.08203L16.4648 6.27734C16.0781 6.07812 15.6797 5.91406 15.2695 5.78516L14.707 3.44531C14.6367 3.1875 14.4023 3 14.1328 3H11.7891C11.5195 3 11.2852 3.1875 11.2148 3.44531L10.6523 5.78516C10.2422 5.91406 9.84375 6.07812 9.45703 6.27734L7.46484 5.08203C7.23047 4.94141 6.9375 4.97656 6.75 5.16406L5.08594 6.82812C4.89844 7.01562 4.86328 7.30859 5.00391 7.54297L6.19922 9.53516C6 9.92188 5.83594 10.3203 5.70703 10.7305L3.44531 11.3047C3.1875 11.3633 3 11.5977 3 11.8672V14.2109C3 14.4805 3.1875 14.7148 3.44531 14.7734L5.70703 15.3477C5.83594 15.7578 6 16.1563 6.19922 16.543L5.00391 18.5352C4.86328 18.7695 4.89844 19.0625 5.08594 19.25L6.75 20.9141C6.9375 21.1016 7.23047 21.1367 7.46484 20.9961L9.45703 19.8008C9.84375 20 10.2422 20.1641 10.6523 20.293L11.2148 22.5547C11.2852 22.8125 11.5195 23 11.7891 23H14.1328C14.4023 23 14.6367 22.8125 14.707 22.5547L15.2695 20.293C15.6797 20.1641 16.0781 20 16.4648 19.8008L18.457 20.9961C18.6914 21.1367 18.9844 21.1016 19.1719 20.9141L20.8359 19.25C21.0234 19.0625 21.0586 18.7695 20.918 18.5352L19.7227 16.543C19.9219 16.1563 20.0859 15.7578 20.2148 15.3477L22.5547 14.7734C22.8125 14.7148 23 14.4805 23 14.2109V11.8672C23 11.5977 22.8125 11.3633 22.5547 11.3047ZM12.9609 15.9688C11.3438 15.9688 10.0312 14.6562 10.0312 13.0391C10.0312 11.4219 11.3438 10.1094 12.9609 10.1094C14.5781 10.1094 15.8906 11.4219 15.8906 13.0391C15.8906 14.6562 14.5781 15.9688 12.9609 15.9688Z" fill="#009BB3"/>
    </svg>
  );
};
/* eslint-enable max-len */

Exploitation.defaultProps = {
  className: null,
};

Exploitation.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Exploitation;
